module.exports = __webpack_public_path__ + "img/eye-on.e881e189.svg";